import axiosInstance from '../axiosInstance';
import baseUrl from '../Base_Url/baseUrl';

export const adminLoginApi = (payload) =>
  axiosInstance.post(`/admin/admin-login`, payload);

export const resetPasswordAdminApi = (payload) =>
  axiosInstance.post(`/admin/reset-password-for-admin`, payload);

export const getSystemListApi = () =>
  axiosInstance.get(`/single-disease-protocol/get-all-system-list `);

export const getDiseaseBySystemApi = (systemCode) =>
  axiosInstance.post(`/single-disease-protocol/get-all-disease-list`, {
    systems: systemCode,
  });

// Disease Protocol Apis
export const getDiseaseProtocolApi = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/single-disease-wise-remedy-protocol`,
    payload,
  );

export const createDiseaseProtocol = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/add-single-disease-protocol`,
    payload,
  );

export const updateDiseaseProtocol = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/update-single-disease-protocol`,
    payload,
  );

export const getDiseaseProtocolById = (id) =>
  axiosInstance.post(
    `/single-disease-protocol/get-single-disease-protocol-by-obj-id`,
    { id },
  );

export const getSystemAxisList = (payload) =>
  axiosInstance.post(`/system-master/system-axis-master-list`, payload);

export const createSystemAxis = (payload) =>
  axiosInstance.post(`/system-master/add-system-axis`, payload);

export const updateSystemAxis = (payload) =>
  axiosInstance.post(`/system-master/update-system-axis`, payload);

export const getSystemAxisListById = (id) =>
  axiosInstance.post(`/system-master/system-axis-master-list-by-id`, { id });

export const saveRemedyProtocolApi = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/save-remedy-protocol-of-admin`,
    payload,
  );

export const createSystemAxisMapping = (payload) =>
  axiosInstance.post(`/disease/addDisease`, payload);

export const getSystemAxisMappingList = (payload) =>
  axiosInstance.post(`/disease/get-disease-list`, payload);

export const getSystemAxisMappingById = (id) =>
  axiosInstance.post(`/disease/get-disease-by-id`, { id });

export const updateSystemAxisMapping = (payload) =>
  axiosInstance.post(`/disease/updateDisease`, payload);

// Disease Protocol Apis
export const uploadMasterFile = (formData) => {
  return axiosInstance.post(
    `/single-disease-protocol/upload-single-disease-protocol`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};

export const diseaseProtocolList = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/disease-protocol-list`,
    payload,
  );

export const getUploadedMasterList = () =>
  axiosInstance.get(`/single-disease-protocol/excel-list`);

export const getMasterFileErrorLogs = () =>
  axiosInstance.get(`/single-disease-protocol/master-file-error-logs`);

export const downloadMasterExcel = (fileName) => {
  return axiosInstance.post(
    `/single-disease-protocol/excel-download-by-file-name`,
    { fileName },
    {
      responseType: 'blob',
    },
  );
};

export const savedDiseaseProtocolList = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/get-admin-remedy-protocol-list`,
    payload,
  );

export const getSavedDiseaseProtocolById = (id) =>
  axiosInstance.post(
    `/single-disease-protocol/get-remedy-protocol-by-obj-id`,
    { id },
  );

// Doctor User Api

export const getDoctorListApi = (payload) =>
  axiosInstance.post(`/doctor/doctors-list`, payload);

export const toggleUserActiveInactive = (payload) => {
  return axiosInstance.post(
    `/doctor/mark-user-account-active-inactive`,
    payload,
  );
};

// Patient History Api

export const patientHistoryList = (payload) =>
  axiosInstance.post(`/doctor/patient-previous-history`, payload);

export const getPatientHistoryById = (id) =>
  axiosInstance.post(`/doctor/protocol-details-by-obj-id`, { id });

// Patient Management Api

export const patientList = (payload) =>
  axiosInstance.post(`/doctor/patient-list`, payload);

export const getPatientById = (id) =>
  axiosInstance.post(`/doctor/get-patient-by-obj-id`, { id });
export const createPatient = (payload) =>
  axiosInstance.post(`/doctor/patient-registration`, payload);

export const updatePatient = (payload) =>
  axiosInstance.post(`/doctor/update-patient-details`, payload);

// Patient Treatment Protocol Api
export const createPatientTreatmentProtocol = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/save-patient-treatment-protocol`,
    payload,
  );

export const patientListForAdmin = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/admin-side-patient-history-list`,
    payload,
  );

export const getHistoryById = (id) =>
  axiosInstance.post(
    `/single-disease-protocol/get-admin-side-patient-history-by-id`,
    { id },
  );

export const addRemark = (payload) =>
  axiosInstance.post(`/doctor/submit-patient-treatment-remark`, payload);

export const downloadApk = (onProgress) => {
  return axiosInstance.get(`/single-disease-protocol/download-apk-file`, {
    responseType: 'blob',

    // ✅ progress tracking
    onDownloadProgress: (progressEvent) => {
      if (!progressEvent.total) return;

      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      );

      onProgress?.(percent);
    },
  });
};
export const patientAllHistoryByObjId = (payload) =>
  axiosInstance.post(
    `/single-disease-protocol/patient-all-history-by-obj-id`,
    payload,
  );

// Plans Management Api
export const addPlan = (payload) =>
  axiosInstance.post(`/plans/add-plan`, payload);
export const updatePlan = (payload) =>
  axiosInstance.post(`/plans/update-plan`, payload);

export const getAllPlansList = () =>
  axiosInstance.get(`/plans/get-all-plans-list`);

export const getPlanById = (id) =>
  axiosInstance.post(`/plans/get-plan-by-obj-id`, { id });

export const deletePlan = (id) =>
  axiosInstance.post(`/plans/delete-plan-record`, { id });

// Custom Notification Api
export const customNotificationList = (payload) =>
  axiosInstance.post(
    `/custom-notification/custom-notification-paginated-list`,
    payload,
  );

export const addCustomNotification = (payload) =>
  axiosInstance.post(`/custom-notification/add-custom-notification`, payload);
export const updateCustomNotification = (payload) =>
  axiosInstance.post(
    `/custom-notification/update-custom-notification`,
    payload,
  );

export const getCustomNotificationById = (id) =>
  axiosInstance.post(
    `/custom-notification/get-custom-notification-by-obj-id`,
    { id },
  );
export const deleteCustomNotificationById = (id) =>
  axiosInstance.post(
    `/custom-notification/delete-custom-notification-by-obj-id`,
    { id },
  );

// Product Management Api

export const addProduct = (payload) =>
  axiosInstance.post(`/product-management/add-product`, payload);

export const productList = (payload) =>
  axiosInstance.post(`/product-management/product-paginated-list`, payload);

export const getProductById = (id) =>
  axiosInstance.post(`/product-management/get-product-by-object-id`, { id });
export const updateProduct = (payload) =>
  axiosInstance.post(`/product-management/update-product`, payload);

export const deleteProductById = (id) =>
  axiosInstance.post(`/product-management/delete-product-by-id`, { id });

// Notification Api
export const getUserNotificationApi = () =>
  axiosInstance.get(`/notification/user-notification`);

// General Information Api
export const generalInformationList = (payload) =>
  axiosInstance.post(
    `/general-information/general-information-list`,
    payload,
  );
export const deleteGeneralInformationById = (id) =>
  axiosInstance.post(
    `/general-information/delete-general-information-by-id`,
    { id },
  );
export const addGeneralInformation = (payload) =>
  axiosInstance.post(`/general-information/add-general-information`, payload);
export const getGeneralInformationById = (id) =>
  axiosInstance.post(`/general-information/get-general-information-by-id`, {
    id,
  });
export const updateGeneralInformation = (payload) =>
  axiosInstance.post(
    `/general-information/update-general-information`,
    payload,
  );

// Application Guidline Api
export const applicationGuidelineList = (payload) =>
  axiosInstance.post(
    `/application-guideline/application-guideline-paginated-list`,
    payload,
  );
export const deleteApplicationGuidelineById = (id) =>
  axiosInstance.post(
    `/application-guideline/delete-application-guideline-by-id`,
    { id },
  );
export const addApplicationGuideline = (payload) =>
  axiosInstance.post(`/application-guideline/add-application-guideline`, payload);
export const getApplicationGuidelineById = (id) =>
  axiosInstance.post(
    `/application-guideline/get-application-guideline-by-id`,
    { id },
  );
export const updateApplicationGuideline = (payload) =>
  axiosInstance.post(
    `/application-guideline/update-application-guideline`,
    payload,
  );

// Electropathy Book

export const bookList = (payload) =>
  axiosInstance.post(`/book/get-paginated-book-list`, payload);

export const getBookById = (id) =>
  axiosInstance.post(`/book/get-book-by-obj-id`, { id });

export const addBook = async (formData) => {
  return axiosInstance.post(`/book/add-book`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteBookById = (id) =>
  axiosInstance.post(`/book/delete-book-by-id`, { id });

export const updateBook = async (formData) => {
  return axiosInstance.post(`/book/update-book`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
// About Section
export const getAboutSection = () =>
  axiosInstance.get(`/about-electropathy/get-about-electropathy-single-record`);

export const getAboutSectionById = (id) =>
  axiosInstance.post(`/about-electropathy/get-about-electropathy-by-obj-id`, {
    id,
  });

export const addAboutSection = (payload) =>
  axiosInstance.post(`/about-electropathy/add-about-electropathy`, payload);

export const updateAboutSection = (payload) =>
  axiosInstance.post(`/about-electropathy/update-about-electropathy`, payload);

// How To Use Application
export const getHowToUseSection = () =>
  axiosInstance.get(`/how-to-use-app/get-how-to-use-app-single-record`);

export const addHowToUseSection = (payload) =>
  axiosInstance.post(`/how-to-use-app/add-how-to-use-application`, payload);

export const updateHowToUseSection = (payload) =>
  axiosInstance.post(`/how-to-use-app/update-how-to-use-application`, payload);

// Data By Protocol Id Api

export const getProtocolDetailsByObjId = (id) =>
  axiosInstance.post(`/doctor/protocol-details-by-obj-id`, { id });
